var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button",class:( _obj = {
    'with-icon': _vm.icon,
    'is-underlined': _vm.underlined,
    'with-border': _vm.border
  }, _obj[("is-" + _vm.type)] = 1, _obj ),attrs:{"to":_vm.to}},[_c('div',{staticClass:"inner"},[_c('span',{staticClass:"label"},[_vm._t("default")],2),(_vm.icon)?_c('Sprite',{attrs:{"name":"arrow-right"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }